// F-PLAN — plug the real Plan pane into the F-SHELL registry seam.
//
// Same seam proof as F-SOURCES (plan §2.1): the feature self-registers via this
// `register.ts`, the barrel `features/index.ts` imports it as a side-effect, and
// the shell renders the Pane — with ZERO edit to any shared shell file. The
// acceptance gate is an EMPTY `git diff origin/main -- src/ui/shell/`.
//
// `labelKey` REUSES the F-SHELL key `shell.tab.plan` (does not duplicate it);
// `order: 30` matches the FROZEN `KNOWN_TABS` slot (sources=10/agent=20/plan=30).

import { createElement } from 'react'
import { registerTab } from '@/ui/shell/tab-registry'
import { PlanPane } from './PlanPane'

registerTab({
  id: 'plan',
  order: 30,
  labelKey: 'shell.tab.plan',
  // Neutral outline glyph (RTL-agnostic — not a direction-implying icon, so
  // no scaleX flip needed per CLAUDE.md §9.2 rule 3).
  icon: createElement('span', { 'aria-hidden': true }, '☰'),
  Pane: PlanPane,
})
